import { Injectable, Injector } from '@angular/core';
import { LocalizationService, PermissionCheckerService } from 'src/assets/lib/eaf-ng2-module';
import { AppSessionService } from 'src/shared/common/session/app-session.service';

import { AppMenu } from './app-menu';
import { AppMenuItem } from './app-menu-item';

@Injectable()
export class AppNavigationService {
  localization: LocalizationService;
  constructor(
    injector: Injector,
    private _permissionCheckerService: PermissionCheckerService,
    private _appSessionService: AppSessionService,
  ) {
    this.localization = injector.get(LocalizationService);
  }

  // getMenu(): AppMenu {
  //       return new AppMenu('MainMenu', 'MainMenu', [
  //           new AppMenuItem('Forms', 'Pages.Forms', 'fab fa-wpforms', '/app/main/forms'),
  //           new AppMenuItem('Quizzes', 'Pages.Quizzes.Create', 'far fa-question-circle', '/app/main/quizzes'),
  //           new AppMenuItem('TypeOfServices', 'Pages.Forms.Type.Create', 'fas fa-server', '/app/main/services'),
  //           new AppMenuItem('Questions', 'Pages.Questions.Create', 'fas fa-list', '/app/main/questions'),
  //       ]);
  //   }

  //   getAdminMenu(): AppMenu {
  //       return new AppMenu('AdminMenu', 'AdminMenu', [
  //           new AppMenuItem('Roles', 'Pages.Administration.Roles', 'flaticon-suitcase', '/app/admin/roles'),
  //           new AppMenuItem('Users', 'Pages.Administration.Users', 'flaticon-users', '/app/admin/users'),
  //           new AppMenuItem('Languages', 'Pages.Administration.Languages', 'flaticon-tabs', '/app/admin/languages'),
  //           new AppMenuItem('AuditLogs', 'Pages.Administration.AuditLogs', 'flaticon-folder-1', '/app/admin/auditLogs'),
  //           new AppMenuItem('VisualSettings', 'Pages.Administration.UiCustomization', 'flaticon-imac', '/app/admin/ui-customization'),
  //           new AppMenuItem('Maintenance', 'Pages.Administration.Maintenance', 'flaticon-lock', '/app/admin/maintenance'),
  //           new AppMenuItem('Settings', 'Pages.Administration.Settings', 'flaticon-settings', '/app/admin/settings'),
  //           new AppMenuItem('Parameters', 'Pages.Administration.Maintenance', 'flaticon-lock', '/app/admin/parameters'),
  //           new AppMenuItem('Jobs', 'Pages.Administration.HangfireDashboard', 'flaticon-line-graph', '/app/admin/hangfire'),
  //       ]);
  //   }

  getMenu(): AppMenu {
    return new AppMenu('MainMenu', 'MainMenu', [
      new AppMenuItem('Briefing', 'Pages.Briefings', 'flaticon-line-graph', '/app/main/briefing'),
      new AppMenuItem('BriefingGol', 'Pages.BriefingGol', 'flaticon-box', '/app/main/briefinggol'),
      new AppMenuItem('FlightMonitoring', 'Pages.FlightsMonitoring', 'flaticon-notepad', '/app/main/flightmonitoring'),
      new AppMenuItem('Minimums', 'Pages.Minimums', 'flaticon-imac', '/app/main/minimums'),
      new AppMenuItem('Occurrence', 'Pages.Occurrences', 'flaticon-imac', '/app/main/occurrence'),
      new AppMenuItem('Research', '', 'flaticon-tabs', '', null, [
        new AppMenuItem('Knowledge', 'Pages.Articles', 'flaticon-squares-4', '/app/main/knowledge'),
        new AppMenuItem('Calendar', 'Pages.Events', 'flaticon-calendar', '/app/main/calendar'),
        new AppMenuItem('Guidelines', 'Pages.Orientations', 'flaticon-squares-4', '/app/main/guidelines'),
        new AppMenuItem('Contacts', 'Pages.Contacts', 'flaticon-users', '/app/main/contacts'),
      ]),
      new AppMenuItem('NetworkDOV', '', 'flaticon-imac', '', null, [
        new AppMenuItem('Commanders', 'Pages.Commanders', 'flaticon-users', '/app/main/commanders'),
        new AppMenuItem('Workscale', 'Pages.WorkShifts', 'flaticon-paper-plane', '/app/main/workscale'),
        new AppMenuItem('ContinuousImprovements', '', 'flaticon-imac', '', null, [
          new AppMenuItem('RootThemes', 'Pages.RootThemes', 'flaticon-paper-plane', '/app/main/rootthemes'),
          new AppMenuItem(
            'ContinuousImprovements',
            'Pages.ContinuousImprovements',
            'flaticon-paper-plane',
            '/app/main/continuousimprovements',
          ),
        ]),
      ]),
      new AppMenuItem('Reporting', '', 'flaticon-folder-1', '', null, [
        new AppMenuItem('Shiftreport', 'Pages.Occurrences.Shiftreport', 'flaticon-line-graph', '/app/main/shiftreport'),
        new AppMenuItem('ExtractDatabase', 'Pages.Occurrences.ExtractDatabase', 'fas fa-coins', '/app/main/extractdatabase'),
        new AppMenuItem('ContributorReport', 'Pages.Occurrences.ContributorReport', 'flaticon-line-graph', '/app/main/contributorreport'),
        new AppMenuItem('WorkscaleReport', 'Pages.WorkShifts.WorkscaleReport', 'flaticon-line-graph', '/app/main/workscalereport'),
      ]),
      new AppMenuItem('Tenants', 'Pages.Tenants', 'flaticon-squares-4', '/app/admin/tenants'),
      new AppMenuItem('Airplanes', 'Pages.Airplanes', 'flaticon-paper-plane', '/app/main/airplanes'),
      new AppMenuItem('MelItem', 'Pages.MELItem', 'flaticon-imac', '/app/main/melitem'),

      new AppMenuItem('BriefingGolRegistrations', '', 'flaticon-folder-1', '', null, [
        new AppMenuItem('Briefing / Notam', 'Pages.Notam', 'flaticon-imac', '/app/main/notam'),
        new AppMenuItem('Database', '', 'flaticon-folder-1', '', null, [
          new AppMenuItem('BriefingAirport', 'Pages.BriefingAirport', 'flaticon-imac', '/app/main/briefingairport'),
          new AppMenuItem('Fir', 'Pages.Fir', 'flaticon-imac', '/app/main/fir'),
          new AppMenuItem('CostIndex', 'Pages.CostIndex', 'flaticon-imac', '/app/main/costindex'),
          new AppMenuItem('CostIndexOperational', 'Pages.OperationalCostIndex', 'flaticon-imac', '/app/main/costindexoperational'),
          new AppMenuItem('City Pair', 'Pages.CityPair', 'flaticon-imac', '/app/main/citypair'),
          new AppMenuItem('AlternateFlightHeaderInfo', 'Pages.AlternateFlight', 'flaticon-imac', '/app/main/alternateflight'),
          new AppMenuItem('FlightTime', 'Pages.FlightTime', 'flaticon-line-graph', '/app/main/flighttime'),
        ]),
      ]),
    ]);
  }

  getAdminMenu(): AppMenu {
    return new AppMenu('AdminMenu', 'AdminMenu', [
      new AppMenuItem('Roles', 'Pages.Administration.Roles', 'flaticon-suitcase', '/app/admin/roles'),
      new AppMenuItem('Users', 'Pages.Administration.Users', 'flaticon-users', '/app/admin/users'),
      new AppMenuItem('Languages', 'Pages.Administration.Languages', 'flaticon-tabs', '/app/admin/languages'),
      new AppMenuItem('AuditLogs', 'Pages.Administration.AuditLogs', 'flaticon-folder-1', '/app/admin/auditLogs'),
      new AppMenuItem('VisualSettings', 'Pages.Administration.UiCustomization', 'flaticon-imac', '/app/admin/ui-customization'),
      new AppMenuItem('Maintenance', 'Pages.Administration.Maintenance', 'flaticon-lock', '/app/admin/maintenance'),
      new AppMenuItem('Settings', 'Pages.Administration.Settings', 'flaticon-settings', '/app/admin/settings'),
      new AppMenuItem('Parameters', 'Pages.Administration.Maintenance', 'flaticon-lock', '/app/admin/parameters'),
      new AppMenuItem('Jobs', 'Pages.Administration.HangfireDashboard', 'flaticon-line-graph', '/app/admin/hangfire'),
    ]);
  }

  checkChildMenuItemPermission(menuItem): boolean {
    for (let i = 0; i < menuItem.items.length; i++) {
      const subMenuItem = menuItem.items[i];

      if (subMenuItem.permissionName && this._permissionCheckerService.isGranted(subMenuItem.permissionName)) {
        return true;
      } else if (subMenuItem.items && subMenuItem.items.length) {
        return this.checkChildMenuItemPermission(subMenuItem);
      }
    }

    return false;
  }

  showMenuItem(menuItem: AppMenuItem): boolean {
    // let hideMenuItem = false;

    // if (menuItem.requiresAuthentication && !this._appSessionService.user) {
    //   hideMenuItem = true;
    // }

    // if (menuItem.permissionName && !this._permissionCheckerService.isGranted(menuItem.permissionName)) {
    //   hideMenuItem = true;
    // }

    // if (menuItem.hasFeatureDependency() && !menuItem.featureDependencySatisfied()) {
    //   hideMenuItem = true;
    // }

    // if (!hideMenuItem && menuItem.items && menuItem.items.length) {
    //   return this.checkChildMenuItemPermission(menuItem);
    // }

    return true;
  }
}
